import React, { useEffect, useState } from "react";
import '../styles/LiveSurvey.css';
import TruveyGreenLogo from '../Asset/Images/XSO-Green.png';
import { useParams, Link } from "react-router-dom";
import SurveyRunService from "../Services/SurveyRunService";

const ParticipantResponse = () => {
    const { uniqueKey } = useParams();

    const [surveyStatus, setSurveyStatus] = useState("");
    const [SurveyName, setSurveyName] = useState();
    const [ResponderName, setResponderName] = useState();
    const [Description, setDescription] = useState();
    const [IsRespondStarted, setIsRespondStarted] = useState();
    const [IsRespondCollected, setIsRespondCollected] = useState();
    const [TimeToStart, setTimeToStart] = useState();
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [isSurveyStarted, setIsSurveyStarted] = useState(false);
    const [totalQuestion, settotalQuestion] = useState(false);
    const [ThankYouNote, setThankYouNote] = useState("");
    const [otherAnswer, setOtherAnswer] = useState("");
    const [IsRequired, setIsRequired] = useState();
    const [OptionType, setOptionType] = useState("");
    const [CompanyLogo, setCompanyLogo] = useState("");
    

    useEffect(() => {  
        const existingUID = getCookie('ResponderUID');
        const existSurveyUID = getCookie('SurveyUID');
        if (existSurveyUID === uniqueKey) {
            if (existingUID) {
                const GetSurveyData = async () => {
                    const response = await SurveyRunService.GetSurveyDetailsByResponder(existingUID);
                    if (response) {
                        const Data = response.RESPONSE;
                        console.log(Data)
                        setSurveyName(Data[0].SurveyName);
                        setResponderName(Data[0].ResponderName);
                        setDescription(Data[0].Description);
                        setIsRespondStarted(Data[0].IsRespondStarted);
                        setIsRespondCollected(Data[0].IsRespondCollected);
                        setTimeToStart(Data[0].TimeToStart);
                        if (Data[0].CompanyLogo !== "") {
                            setCompanyLogo(Data[0].CompanyLogo);
                        }
                        if (Data[0].SurveyStatus) {
                            setSurveyStatus(Data[0].SurveyStatus);
                            if (Data[0].SurveyStatus === "Scheduled to Start") {
                                setTimeToStart(Data[0].TimeToStart);
                            }
                        }
                    }
                };
                GetSurveyData();
            }
        }
        else {
            const GetSurveyData = async () => {
                const response = await SurveyRunService.GetSurveyDataOnSurveyID(uniqueKey);
                if (response) {
                    const Data = response.SURVEY_DETAILS;
                    console.log(Data)
                    setSurveyName(Data[0].SurveyName);
                    setDescription(Data[0].Description);
                    setIsRespondStarted(Data[0].IsRespondStarted);
                    setIsRespondCollected(Data[0].IsRespondCollected);
                    if (Data[0].CompanyLogo !== "") {
                        setCompanyLogo(Data[0].CompanyLogo);
                    }
                    if (Data[0].SurveyStatus) {
                        setSurveyStatus(Data[0].SurveyStatus);
                        if (Data[0].SurveyStatus === "Scheduled to Start") {
                            if (!Data[0].TimeToStart === undefined || !Data[0].TimeToStart === null) {
                                setTimeToStart(Data[0].TimeToStart);
                            }
                        }
                    }
                }
            };
            GetSurveyData();
        }
        if (TimeToStart <= 0) return;
        const timer = setInterval(() => {
            setTimeToStart((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(timer);

    }, [uniqueKey, TimeToStart]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };
    const startSurvey = async () => {
        try {
            const existingUID = getCookie('ResponderUID');
            const existSurveyUID = getCookie('SurveyUID');
            if (existSurveyUID === uniqueKey) {
                if (existingUID) {
                        setIsSurveyStarted(true);
                        const response = await SurveyRunService.StartSurvey(existingUID);
                        if (response.STATUS === 'SUCCESS' && response.STATUSCODE === '200') {
                            const questionData = response.RESPONSE[0];
                            console.log(response.RESPONSE)
                            console.log(questionData)
                            setCurrentQuestion(questionData);
                            if (questionData?.QuestionName === "What is your name ?" || questionData?.QuestionName === "what is your name") {
                                if (questionData.UserAnswer === ResponderName) {
                                    setSelectedAnswer(ResponderName);
                                } else if (questionData.UserAnswer === "") {
                                    setSelectedAnswer(ResponderName);
                                } else {
                                    setSelectedAnswer(questionData.UserAnswer);
                                }
                            }
                            if (questionData.OptionType) {
                                setOptionType(questionData.OptionType);
                            }
                            setIsRequired(questionData.IsRequired);
                            settotalQuestion(questionData.TotalQuestion);
                        } else {
                            console.error('Failed to start survey:', response.MESSAGE);
                        }
                }
            }
            else{
            setIsSurveyStarted(true);
            const ResponderUID=generateUID();
            const expires = new Date();
            expires.setFullYear(expires.getFullYear() + 20);
            document.cookie = `ResponderUID=${encodeURIComponent(ResponderUID)}; ` +
            `expires=${expires.toUTCString()}; ` +
            `path=/; ` +
            `SameSite=Strict; ` +
            `Secure`;
            document.cookie = `SurveyUID=${encodeURIComponent(uniqueKey)}; ` +
            `expires=${expires.toUTCString()}; ` +
            `path=/; ` +
            `SameSite=Strict; ` +
            `Secure`;
            const response = await SurveyRunService.StartSurveySingle(uniqueKey,ResponderUID);
            if (response.STATUS === 'SUCCESS' && response.STATUSCODE === '200') {
                const questionData = response.RESPONSE[0];
                console.log(response.RESPONSE)
                console.log(questionData)
                setCurrentQuestion(questionData);
                if (questionData?.QuestionName === "What is your name ?" || questionData?.QuestionName === "what is your name") {
                    if (questionData.UserAnswer === ResponderName) {
                        setSelectedAnswer(ResponderName);
                    } else if (questionData.UserAnswer === "") {
                        setSelectedAnswer(ResponderName);
                    } else {
                        setSelectedAnswer(questionData.UserAnswer);
                    }
                }
                if (questionData.OptionType) {
                    setOptionType(questionData.OptionType);
                }
                setIsRequired(questionData.IsRequired);
                settotalQuestion(questionData.TotalQuestion);
            } else {
                console.error('Failed to start survey:', response.MESSAGE);
            }
        }
        } catch (error) {
            console.error('Error starting survey:', error);
        }
    };
    const nextQuestion = async () => {
        try {
            let answerToCheck = selectedAnswer;
            const IsOtherAnswer = otherAnswer;
            if (currentQuestion?.QuestionName === "What is your name ?" || currentQuestion?.QuestionName === "what is your name") {
                if (selectedAnswer === ResponderName) {
                    answerToCheck = ResponderName;
                }
                setSelectedAnswer(ResponderName);
            }
            if (IsOtherAnswer) {
                answerToCheck = otherAnswer;
            }

            if (IsRequired === 1) {
                if (!answerToCheck || answerToCheck.trim() === "") {
                    alert("Answer is required and cannot be empty.");
                    return;
                }
                if (OptionType === "Mobile Number") {
                    const mobileRegex = /^[0-9]{10}$/;
                    if (!mobileRegex.test(answerToCheck)) {
                        alert("Please enter a valid mobile number.");
                        return;
                    }
                } else if (OptionType === "Email") {
                    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                    if (!emailRegex.test(answerToCheck)) {
                        alert("Please enter a valid email address.");
                        return;
                    }
                } else if (OptionType === "Answer in Number") {
                    if (isNaN(answerToCheck)) {
                        alert("Please enter a valid number.");
                        return;
                    }
                } else {
                    if (selectedAnswer === "Other") {
                        if (!IsOtherAnswer) {
                            alert("Answer is required and cannot be empty.");
                            return;
                        }
                    }
                }
            } else if (IsRequired === 0) {
                if (answerToCheck  && answerToCheck.trim() !== "") {
                    if (OptionType === "Mobile Number") {
                        const mobileRegex = /^[0-9]{10}$/;
                        if (!mobileRegex.test(answerToCheck)) {
                            alert("Please enter a valid mobile number.");
                            return;
                        }
                    } else if (OptionType === "Email") {
                        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                        if (!emailRegex.test(answerToCheck)) {
                            alert("Please enter a valid email address.");
                            return;
                        }
                    } else if (OptionType === "Answer in Number") {
                        if (isNaN(answerToCheck)) {
                            alert("Please enter a valid number.");
                            return;
                        }
                    }
                }
            }
            const ResponderUID = getCookie('ResponderUID');
            const response = await SurveyRunService.NextQuestion(
                ResponderUID,
                currentQuestion.QuestionID,
                answerToCheck
            );
            if (response.STATUS === 'SUCCESS' && response.STATUSCODE === '200') {
                const questionData = response.RESPONSE[0];
                setOtherAnswer(null);
                console.log(questionData);
                settotalQuestion(questionData.TotalQuestion)
                setCurrentQuestion(questionData);
                if (questionData.UserAnswer) {
                    if (questionData.OptionType === "Check Boxes" || questionData.OptionType === "Multiple Choice") {
                        if (questionData.UserAnswer) {
                            const optionsString = response.RESPONSE[0].Options.map(option => option.OptionName).join(", ");
                            const hasOther = optionsString.includes("Other");
                            if (hasOther) {
                                if (optionsString.includes(questionData.UserAnswer)) {
                                    setSelectedAnswer(questionData.UserAnswer);
                                    setOtherAnswer("");
                                } else {
                                    setSelectedAnswer("Other");
                                    setOtherAnswer(questionData.UserAnswer || "");
                                }
                            } else {
                                setSelectedAnswer(questionData.UserAnswer);
                                setOtherAnswer("");
                            }
                        }
                    } else {
                        setSelectedAnswer(questionData.UserAnswer);
                        setOtherAnswer("");
                    }
                } else {
                    setSelectedAnswer(null);
                }
                if (questionData.OptionType) {
                    setOptionType(questionData.OptionType);
                }
                setIsRequired(questionData.IsRequired);

            } else {
                console.error('Failed to fetch the next question:', response.MESSAGE);
            }
        } catch (error) {
            console.error('Error fetching next question:', error);
        }
    };
    const FinishSurvey = async () => {
        const isConfirmed = window.confirm("Are you sure ? You want to submit your response ?");
        if (isConfirmed) {
            try {
                if (!selectedAnswer) {
                    alert("Please select or enter an answer before proceeding.");
                    return;
                }
                const ResponderUID = getCookie('ResponderUID');

                const response = await SurveyRunService.FinishSurvey(ResponderUID, currentQuestion.QuestionID, selectedAnswer);

                if (response.STATUS === 'SUCCESS' && response.STATUSCODE === '200') {
                    const questionData = response.RESPONSE;
                    setThankYouNote(questionData);
                } else {
                    console.error('Failed to fetch the next question:', response.MESSAGE);
                }
            } catch (error) {
                console.error('Error fetching next question:', error);
            }
        }
    };
    const handleAnswerChange = (value) => {
        setSelectedAnswer(value);
    };
    const renderQuestionInput = () => {
        switch (currentQuestion?.OptionType) {
            case "Multiple Choice":
                return currentQuestion.Options.map((option) => (
                    <div key={option.OptionName}>
                        <input
                            type="radio"
                            name="options"
                            id={`option_${option.OptionName}`}
                            value={option.OptionName}
                            checked={selectedAnswer === option.OptionName}
                            onChange={() => {
                                if (option.OptionName === "Other") {
                                    setSelectedAnswer(option.OptionName);
                                } else {
                                    setSelectedAnswer(option.OptionName);
                                    setOtherAnswer("");
                                }
                            }}
                            className="me-2"
                            required={IsRequired === 1}
                        />
                        <label htmlFor={`option_${option.OptionName}`} className="d-inline">{option.OptionName}</label>

                        {/* If the option is "Other", show a text input field */}
                        {option.OptionName === "Other" && selectedAnswer === "Other" && (
                            <input
                                type="text"
                                className="form-control mt-2"
                                value={otherAnswer || ""}
                                onChange={(e) => setOtherAnswer(e.target.value)} // Update the custom answer
                                placeholder="Please specify"
                                required={IsRequired === 1}
                            />
                        )}
                    </div>
                ));
            case "Check Boxes":
                return currentQuestion.Options.map((option) => (
                    <div key={option.OptionName}>
                        <input
                            type="checkbox"
                            id={`option_${option.OptionName}`}
                            value={option.OptionName}
                            checked={selectedAnswer?.split("||").includes(option.OptionName)}
                            onChange={(e) => {
                                let updatedAnswer = selectedAnswer ? selectedAnswer.split("||") : [];
                                    
                                if (e.target.checked) {
                                    updatedAnswer.push(option.OptionName);
                                } else {
                                    updatedAnswer = updatedAnswer.filter((o) => o !== option.OptionName);
                                }

                                // Set the updated answer
                                handleAnswerChange(updatedAnswer.join("||"));

                                // Clear "Other" answer if it's not selected
                                if (!updatedAnswer.includes("Other")) {
                                    setOtherAnswer("");
                                }
                            }}
                            required={IsRequired === 1}
                            className="me-2"
                        />
                        <label htmlFor={`option_${option.OptionName}`} className="d-inline">{option.OptionName}</label>

                        {/* If the option is "Other", show a text input field */}
                        {option.OptionName === "Other" && selectedAnswer?.split(",").includes("Other") && (
                            <input
                                type="text"
                                className="form-control mt-2"
                                value={otherAnswer || ""}
                                onChange={(e) => setOtherAnswer(e.target.value)} // Update the custom answer
                                placeholder="Please specify"
                                required={IsRequired === 1}
                            />
                        )}
                    </div>
                ));
            case "Short Answer":
                const defaultValue =
                    currentQuestion?.QuestionName === "What is your name ?"
                        ? ResponderName
                        : selectedAnswer;
                return (

                    <input
                        type="text"
                        className="form-control"
                        value={selectedAnswer || defaultValue || ""}
                        onChange={(e) => handleAnswerChange(e.target.value)}
                        required={IsRequired === 0}
                    />
                );
            case "Paragraph":
                return (
                    <textarea
                        className="form-control"
                        rows="5"
                        value={selectedAnswer || ""}
                        onChange={(e) => handleAnswerChange(e.target.value)}
                        required={IsRequired === 1}
                    />
                );
            case "Date":
                return (
                    <input
                        type="date"
                        className="form-control"
                        value={selectedAnswer || ""}
                        onChange={(e) => handleAnswerChange(e.target.value)}
                        required={IsRequired === 1}
                    />
                );
            case "Answer in Number":
                return (
                    <input
                        type="number"
                        className="form-control"
                        value={selectedAnswer || ""}
                        onChange={(e) => handleAnswerChange(e.target.value)}
                        required={IsRequired === 1}
                    />
                );
            case "Mobile Number":
                return (
                    <input
                        type="tel"
                        className="form-control"
                        value={selectedAnswer || ""}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,10}$/.test(value)) {
                                handleAnswerChange(value);
                            }
                        }}
                        maxLength="10"
                        required={IsRequired === 1}
                    />
                );
            case "Email":
                return (
                    <input
                        type="email"
                        className="form-control"
                        value={selectedAnswer || ""}
                        onChange={(e) => handleAnswerChange(e.target.value)}
                        required={IsRequired === 1}
                    />
                );
            case "Rating bar":
                return (
                    <div className="col-5 d-flex flex-column">
                        <h3 className="text-center">{selectedAnswer || 1}</h3>
                        <input
                            type="range"
                            min="1"
                            max="10"
                            value={selectedAnswer || 1}
                            onChange={(e) => handleAnswerChange(e.target.value)}
                            required={IsRequired === 1}
                            className="w-100"
                        />
                        <div className="d-flex justify-content-between">
                            {[...Array(10)].map((_, index) => {
                                const number = index + 1; // Numbers from 1 to 10
                                return (
                                    <span
                                        key={number}
                                        onClick={() => handleAnswerChange(number.toString())} // Update selectedAnswer
                                        style={{ cursor: "pointer" }} // Change cursor to pointer for better UX
                                    >
                                        <div className="RateBorder"></div> {number}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                );

            default:
                return <p>Unsupported question type.</p>;
        }
    };
    const PreviousQuestion = async () => {
        try {
            const ResponderUID = getCookie('ResponderUID');
            const response = await SurveyRunService.PreviousQuestion(ResponderUID, currentQuestion.QuestionID, selectedAnswer);
            if (response.STATUS === 'SUCCESS' && response.STATUSCODE === '200') {
                const questionData = response.RESPONSE[0];
                console.log(response);
                settotalQuestion(questionData.TotalQuestion)
                setCurrentQuestion(questionData);
                if (questionData.OptionType === "Check Boxes" || questionData.OptionType === "Multiple Choice") {
                    if (questionData.UserAnswer) {
                        const optionsString = response.RESPONSE[0].Options.map(option => option.OptionName).join(", ");
                        const hasOther = optionsString.includes("Other");
                        if (hasOther) {
                            if (optionsString.includes(questionData.UserAnswer)) {
                                setSelectedAnswer(questionData.UserAnswer);
                                setOtherAnswer("");
                            } else {
                                setSelectedAnswer("Other");
                                setOtherAnswer(questionData.UserAnswer || "");
                            }
                        } else {
                            setSelectedAnswer(questionData.UserAnswer);
                            setOtherAnswer("");
                        }
                    }
                } else {
                    setSelectedAnswer(questionData.UserAnswer);
                    setOtherAnswer("");
                }
                if (questionData.OptionType) {
                    setOptionType(questionData.OptionType);
                }
                setIsRequired(questionData.IsRequired);

            } else {
                console.error('Failed to fetch the next question:', response.MESSAGE);
            }
        } catch (error) {
            console.error('Error fetching next question:', error);
        }
    };
    const getSurveyContent = () => {
        switch (surveyStatus) {
            case "Active":
                return (
                    <>
                        {!isSurveyStarted ? (
                            <>
                                <div>
                                    {
                                        IsRespondCollected === true ?
                                            (<>
                                            </>) : (<>
                                                  <h5 className="border-bottom2px">Welcome {ResponderName}</h5>
                                            </>)
                                    }
                                </div>
                                <div className="shadow bg-white p-5 min-hight400px w-100 d-flex justify-content-between flex-column LiveSurveyDiv">
                                    <div>
                                        <h5 className="fs-18">{SurveyName}</h5>
                                        <p className="fs-14 text-justify">{Description}</p>
                                    </div>
                                    <div className="text-end">
                                        {
                                            IsRespondCollected === true ?
                                                (<>
                                                    <p className="text-success">
                                                        Thank you
                                                        <br />
                                                        Response already captured.
                                                    </p>
                                                </>) :
                                                (<>
                                                    <button className="border-0 px-4 py-1 TruveyBG text-white" onClick={startSurvey}>
                                                        {
                                                            IsRespondStarted === true ?
                                                                (<>
                                                                    Continue Survey
                                                                </>) :
                                                                (<>
                                                                    Start Survey
                                                                </>)
                                                        }
                                                    </button>
                                                </>)
                                        }

                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="shadow bg-white p-4 w-100 d-flex justify-content-between flex-column LiveSurveyDiv">
                                    <div>
                                        <h5>
                                            {currentQuestion?.QuestionName} <span className={IsRequired ? "text-danger" : "d-none"}>*</span>
                                        </h5>
                                        <div>

                                            {renderQuestionInput()}
                                        </div>
                                    </div>
                                    <div className="text-end mt-5">
                                        {
                                            currentQuestion ? (<>
                                                {currentQuestion.QuestionID >= 2 && (
                                                    <button
                                                        className="border-0 px-4 py-1 TruveyBG text-white me-2"
                                                        onClick={PreviousQuestion}
                                                    >
                                                        Previous
                                                    </button>
                                                )}
                                            </>) : (<></>)
                                        }

                                        {
                                            currentQuestion ? (
                                                totalQuestion == currentQuestion.QuestionID ? (
                                                    <>
                                                        <button
                                                            className="border-0 px-4 py-1 TruveyBG text-white"
                                                            onClick={FinishSurvey}
                                                        >
                                                            Finish
                                                        </button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <button
                                                            className="border-0 px-4 py-1 TruveyBG text-white"
                                                            onClick={nextQuestion}
                                                        >
                                                            Next
                                                        </button>
                                                    </>
                                                )
                                            ) : (
                                                <p>Loading...</p> // or display an error message or placeholder until the question is loaded
                                            )}

                                    </div>
                                </div>
                            </>
                        )}
                    </>
                );
            case "Incomplete":
                return (<>
                    <div>
                        <h5 className="border-bottom2px">Welcome {ResponderName}</h5>
                    </div>
                    <div className="shadow bg-white p-5 min-hight400px w-100 d-flex justify-content-between flex-column LiveSurveyDiv">
                        <div>
                            <h5 className="fs-18">{SurveyName}</h5>
                            <p className="fs-14 text-justify">{Description}</p>
                        </div>
                        <div className="text-end">

                            <p className="text-success">
                                Survey will start soon.
                            </p>
                        </div>
                    </div>
                </>);
            case "Scheduled to start":
                return (
                    <>
                        <div>
                            <h5 className="border-bottom2px">Welcome {ResponderName}</h5>
                        </div>
                        <div className="shadow bg-white p-5 min-hight400px w-100">
                            <div>
                                <div>
                                    <h5 className="fs-18">{SurveyName}</h5>
                                    <p className="fs-14 text-justify">{Description}</p>
                                </div>
                                <p className="text-center">Survey will start in: <span className="text-danger"> {TimeToStart > 0 ? formatTime(TimeToStart) : "Survey has started!"} </span></p>
                            </div>
                        </div>
                    </>
                );
            case "Survey Ended":
                return (
                    <>
                        <div>
                            <h5 className="border-bottom2px">Welcome {ResponderName}</h5>
                        </div>
                        <div className="shadow bg-white p-5 min-hight400px w-100 d-flex justify-content-between flex-column LiveSurveyDiv">
                            <div>
                                <h5 className="fs-18">{SurveyName}</h5>
                                <p className="fs-14 text-justify">{Description}</p>
                            </div>
                            <div className="text-end">

                                <p className="text-success">
                                    Survey has been ended.
                                </p>
                            </div>
                        </div>
                    </>
                );
            case "Inactive":
                return (
                    <>
                        <div className="shadow bg-white p-5 min-hight400px w-100 d-flex justify-content-between flex-column">
                            <h4 className="text-center">Survey is inactive. Please contact the administrator.</h4>
                        </div>
                    </>
                );
            default:
                return <p className="shadow bg-white p-5 w-100 d-flex justify-content-between flex-column LiveSurveyDiv text-center min-hight75vh">Invalid survey status.</p>;
        }

    }
    function generateUID(length = 15) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }
      
    return (
        <>
            <div className="container-fuild bg-grey py-3">
                <div className="container min-hight85vh d-flex flex-wrap  justify-content align-items-center LiveSurveyMainDiv">
                   <div className="mb-3 p-3">
                       <img src={CompanyLogo && CompanyLogo !== "" ? CompanyLogo : TruveyGreenLogo} alt="Truvey Logo" className="Img-Set2" />
                    </div>
                    <div className="min-hight75vh d-flex justify-content-center align-items-center flex-column mx-auto w-100">
                        {ThankYouNote ? (<>
                            <div>
                                <h5 className="border-bottom2px">Welcome {ResponderName}</h5>
                            </div>
                            <div className="shadow bg-white p-5 min-hight400px w-100 d-flex justify-content-between flex-column">
                                <div>
                                    <h5>Thank You</h5>
                                    <p className="text-justify">{ThankYouNote}</p>
                                    <Link to="/">Click here to go home page</Link>
                                </div>
                            </div>
                        </>) :
                            (<>
                                {getSurveyContent()}
                            </>)
                        }
                    </div>
                    <div className="text-center mb-3 p-3 w-100 text-center">
                        Survey Conduct on <Link to="/" className="">   <img src={TruveyGreenLogo} alt="Truvey Logo" className="Img-Set" /></Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ParticipantResponse; 
